export const colors = {
    heroBlue: '#2700FF',
    white: '#FFF',
    offWhite: '#F1F0E7',
    twitchPurple: '#9146FF',
    black: '#000',
}



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/constants.js